// src/utils/roles.js

export const ROLES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  MANAGER: 'manager',
  FRONT_DESK: 'front_desk',
  PORTFOLIO_MANAGER: 'portfolio_manager',
  ACCOUNTANT: 'accountant',
  LEASING_AGENT: 'leasing_agent',
  VENDOR: 'vendor',
  TENANT: 'tenant',
  OWNER: 'owner'
};

// Groups
export const STAFF_ROLES = [
  ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, 
  ROLES.PORTFOLIO_MANAGER, ROLES.ACCOUNTANT, ROLES.LEASING_AGENT
];
export const ADMIN_ONLY = [ROLES.ADMIN, ROLES.SUPER_ADMIN];
export const FINANCIAL_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.ACCOUNTANT, ROLES.PORTFOLIO_MANAGER];
export const PAYMENT_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.ACCOUNTANT, ROLES.FRONT_DESK];
export const BASIC_REPORT_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.PORTFOLIO_MANAGER, ROLES.ACCOUNTANT, ROLES.LEASING_AGENT];
export const FINANCIAL_REPORT_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.ACCOUNTANT, ROLES.PORTFOLIO_MANAGER];
export const LEASING_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.PORTFOLIO_MANAGER, ROLES.LEASING_AGENT];
export const LEASE_APPLICATION_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.LEASING_AGENT];
export const MAINTENANCE_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.PORTFOLIO_MANAGER, ROLES.VENDOR];
export const SETTINGS_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN]; // Strictly admin/super_admin for systemic settings
export const OWNER_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.PORTFOLIO_MANAGER];
export const PORTFOLIO_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.PORTFOLIO_MANAGER, ROLES.ACCOUNTANT];
export const MANAGEMENT_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER];
export const PROPERTY_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.PORTFOLIO_MANAGER, ROLES.ACCOUNTANT, ROLES.LEASING_AGENT];
export const WAITLIST_WRITE_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.LEASING_AGENT];
export const SCREENING_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.LEASING_AGENT, ROLES.PORTFOLIO_MANAGER];
export const FINANCIAL_DATA_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.ACCOUNTANT, ROLES.PORTFOLIO_MANAGER];
export const MATERIALS_ROLES = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, ROLES.PORTFOLIO_MANAGER, ROLES.ACCOUNTANT];

// General operation (everything except Vendor/Tenant/Owner)
export const OPERATIONAL_ROLES = [
  ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER, ROLES.FRONT_DESK, 
  ROLES.PORTFOLIO_MANAGER, ROLES.ACCOUNTANT, ROLES.LEASING_AGENT
];

// Helper methods for UI conditionals
export const isStaff = (role) => STAFF_ROLES.includes(role);
export const isAdmin = (role) => ADMIN_ONLY.includes(role);
export const canManageFinancials = (role) => FINANCIAL_ROLES.includes(role);
export const canManagePayments = (role) => PAYMENT_ROLES.includes(role);
export const canViewBasicReports = (role) => BASIC_REPORT_ROLES.includes(role);
export const canViewFinancialReports = (role) => FINANCIAL_REPORT_ROLES.includes(role);
export const canViewReports = (role) => canViewBasicReports(role); // Base reports access
export const canManageLeases = (role) => LEASING_ROLES.includes(role);
export const canManageLeaseApplications = (role) => LEASE_APPLICATION_ROLES.includes(role);
export const canManageMaintenance = (role) => MAINTENANCE_ROLES.includes(role);
export const canManagePortfolio = (role) => PORTFOLIO_ROLES.includes(role);
export const canManageOwners = (role) => OWNER_ROLES.includes(role);
export const canManageProperties = (role) => PROPERTY_ROLES.includes(role);
export const canManageSettings = (role) => SETTINGS_ROLES.includes(role);
export const isManagement = (role) => MANAGEMENT_ROLES.includes(role);
export const canManageWaitlist = (role) => WAITLIST_WRITE_ROLES.includes(role);
export const canOperateSystem = (role) => OPERATIONAL_ROLES.includes(role);
export const canManageScreening = (role) => SCREENING_ROLES.includes(role);
export const canManageFinancialData = (role) => FINANCIAL_DATA_ROLES.includes(role);
export const canManageMaterials = (role) => MATERIALS_ROLES.includes(role);

// Formats "portfolio_manager" down to "Portfolio Manager" for the UI Navbars
export const formatRoleName = (role) => {
  if (!role) return '';
  return role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

